import { useContext, useMemo, useReducer } from 'react'
import { useIntl } from 'react-intl'
import ModalBase from 'LuxKit/Modal/ModalBase'
import type { LuxAwardModalDispatchAction, LuxAwardModalState } from './LuxAwardModalContexts'
import { luxAwardInitialState, LuxAwardModalDispatchContext, LuxAwardModalStateContext, luxAwardModalStateReducer } from './LuxAwardModalContexts'
import LuxAwardModalStepHome from './LuxAwardModalStepHome'
import { getLuxAwardPrizes } from './luxAwardPrizes'
import LuxAwardModalStepPrize from './LuxAwardModalStepPrize'
import { useAppSelector } from 'hooks/reduxHooks'
import GeoContext from 'contexts/geoContext'

const REGIONS_URL_MAPPING: Record<string, string> = {
  '/campaign/lux-list-travel-awards': 'AU',
  '/campaign/lux-list-travel-awards-prizes': 'AU',
  '/campaign/lux-list-travel-awards-us': 'US',
  '/campaign/lux-list-travel-awards-prizes-us': 'US',
  '/campaign/lux-list-travel-awards-uk': 'GB',
  '/campaign/lux-list-travel-awards-prizes-uk': 'GB',
}

const EXPLORE_URLS: Record<string, string> = {
  AU: '/campaign/lux-list-awards-explore',
  US: '/campaign/lux-list-awards-explore-us',
  GB: '/campaign/lux-list-awards-explore-uk',
  NZ: '/campaign/lux-list-awards-explore',
}

const getActiveRegionCode = (pathname: string, currentRegionCode: string) => {
  if (REGIONS_URL_MAPPING[pathname.slice(3)] !== 'AU') {
    return REGIONS_URL_MAPPING[pathname.slice(3)]
  } else if (!['AU', 'NZ'].includes(currentRegionCode)) {
    return 'AU'
  } else if (!currentRegionCode || currentRegionCode.length === 0) {
    return 'AU'
  }
  return currentRegionCode
}

function LuxAwardModal() {
  const intl = useIntl()
  const [state, dispatch] = useReducer<LuxAwardModalState, [LuxAwardModalDispatchAction]>(luxAwardModalStateReducer, luxAwardInitialState)
  const prizes = useMemo(() => getLuxAwardPrizes(intl), [intl])

  const pathname = useAppSelector((state) => state.router.location.pathname)
  const { currentRegionCode } = useContext(GeoContext)
  const activeRegionCode = getActiveRegionCode(pathname, currentRegionCode)
  const exploreUrl = EXPLORE_URLS[activeRegionCode]

  return <ModalBase size="L">
    <LuxAwardModalStateContext.Provider value={state}>
      <LuxAwardModalDispatchContext.Provider value={dispatch}>
        {state.currentStep === 'home' && <LuxAwardModalStepHome exploreUrl={exploreUrl} activeRegionCode={activeRegionCode} />}
        {prizes.map((prize) => (state.currentStep === prize.key) && <LuxAwardModalStepPrize key={prize.key} prizeKey={prize.key} exploreUrl={exploreUrl} />)}
      </LuxAwardModalDispatchContext.Provider>
    </LuxAwardModalStateContext.Provider>
  </ModalBase>
}

export default LuxAwardModal
